import { useQuery } from '@tanstack/react-query'

import { fetchProvinces, fetchWardsByProvince } from '@/lib/api/provinces-api'

export const provinceKeys = {
    all: ['vn-provinces'] as const,
    list: () => [...provinceKeys.all, 'list'] as const,
    wards: (provinceCode: string) =>
        [...provinceKeys.all, 'wards', provinceCode] as const,
}

export function useProvinces() {
    return useQuery({
        queryKey: provinceKeys.list(),
        queryFn: fetchProvinces,
        staleTime: Infinity,
        gcTime: Infinity,
    })
}

export function useWards(provinceCode: string | undefined) {
    return useQuery({
        queryKey: provinceCode
            ? provinceKeys.wards(provinceCode)
            : [...provinceKeys.all, 'wards', '__none__'],
        queryFn: () => fetchWardsByProvince(provinceCode!),
        enabled: !!provinceCode,
        staleTime: Infinity,
        gcTime: Infinity,
    })
}
